exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_checkboxSkeletonWrapper_3yeODlry3IaEbnFUV_xQjx {\n  display: flex;\n  margin-top: 10px;\n  width: 100%;\n}\n\n.IA_checkboxWrapper_1UnQnZjyMrzCsaE_kgKYnA {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-top: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_checkboxSkeletonWrapper": "IA_checkboxSkeletonWrapper_3yeODlry3IaEbnFUV_xQjx",
	"IA_checkboxWrapper": "IA_checkboxWrapper_1UnQnZjyMrzCsaE_kgKYnA"
};